export default "__VITE_ASSET__7e0835f4__"